export type AuditRating = "" | "F" | "N" | "G" | "E";
export type AuditAnswer = "" | "yes" | "no";
export type AuditSection =
  | "safety"
  | "cementJob"
  | "labEquipment1"
  | "labEquipment2"
  | "labEquipment3"
  | "sampling"
  | "labTestingProcedures1"
  | "labTestingProcedures2";

export interface AuditQuestion {
  id: string;
  text: string;
  group?: string;
}

export interface AuditResponse {
  answer: AuditAnswer;
  rating: AuditRating;
  comments: string;
}

export interface LabPersonnel {
  name: string;
  jobTitle: string;
  workExperience: string;
}

export interface AuditInformation {
  country: string;
  auditDateFrom: string;
  auditDateTo: string;
  reportDate: string;
  location: string;
  serviceCompany: string;
  auditors: string;
  laboratoryPersonnelCount: number | null;
  totalLabWorkingHours: number | null;
  workingHoursFrom: string;
  workingHoursTo: string;
}

export interface AuditSectionState {
  responses: Record<string, AuditResponse>;
  fields: Record<string, string>;
  additionalComments: string;
}

export interface LabAuditState {
  information: AuditInformation;
  personnel: LabPersonnel[];
  safety: AuditSectionState;
  cementJob: AuditSectionState;
  labEquipment1: AuditSectionState;
  labEquipment2: AuditSectionState;
  labEquipment3: AuditSectionState;
  sampling: AuditSectionState;
  labTestingProcedures1: AuditSectionState;
  labTestingProcedures2: AuditSectionState;
}

export interface AuditScoreRow {
  label: string;
  score: number | null;
  maximumScore: number | null;
  compatibility: number | null;
}

export const RATING_POINTS: Record<Exclude<AuditRating, "">, number> = {
  F: 0,
  N: 2,
  G: 4,
  E: 5,
};
